export const COMPARISON = "comparison";
export const ICON = "icon";
export const MENU = "menu";
export const NONE = "none";
export const REPORT = "report";
